export default __webpack_public_path__ + "static/media/cdmCases.d2564a11.png";